import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ValidateFiscalCode, ValidationResponse } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface ValidateFiscalCodeParams extends DefaultHttpHeaders {}

@Injectable()
export class ValidateFiscalCodeService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Validate fiscal code
   * Validate fiscal code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/postValidateFiscalCode
   */
  validateFiscalCode(body: ValidateFiscalCode, params: ValidateFiscalCodeParams): Observable<ValidationResponse> {
    return this.post<ValidateFiscalCode, ValidationResponse>({
      suffix: '/comeround/applicationUtilities/validateFiscalCode',
      body,
    });
  }
}
